import api from '@/plugins/axios'

const base = 'v1/site/parceiro/'

export default {
    new(data) {
        return api.post(base + 'solicitar-cadastro', data)
    },
}
